import { MenuProps } from "src/assets/imports/antdComponents";

export interface IArticleNode {
	key: string;
	id: string;
	label: string;
	content: string;
	children?: IArticleNode[];
}

export interface IArticleWithPath extends IArticleNode {
	parentPath?: string[];
}

export type MenuClickEvent = Parameters<MenuProps["onClick"]>[0];

export interface IMediaData {
	url: string;
	type: "image" | "video";
	fetchedAt: number;
	expiresAt?: number;
	captionsUrl?: string;
	chaptersUrl?: string;
	posterUrl?: string;
}

export interface IMediaImageProps {
	id: string;
	alt?: string;
	title?: string;
	className?: string;
	width?: string;
	height?: string;
	rootMargin?: string;
	threshold?: number;
}

export interface IMediaVideoProps {
	id: string;
	title?: string;
	type?: string;
	height?: string;
	width?: string;
	autoPlay?: boolean;
	loop?: boolean;
	muted?: boolean;
	rootMargin?: string;
	threshold?: number;
}

export interface IGenericVideoPlayerProps {
	videoUrl: string;
	type?: string;
	height?: string | number;
	width?: string | number;
	customFullscreen?: boolean;
	captionsUrl?: string;
	chaptersUrl?: string;
	posterUrl?: string;
	title?: string;
	autoPlay?: boolean;
	loop?: boolean;
	muted?: boolean;
	onEnded?: () => void;
	onError?: (error: React.SyntheticEvent<HTMLVideoElement>) => void;
	onFullscreenChange?: (isFullscreen: boolean) => void;
}

export interface IChapter {
	id: string;
	startTime: number;
	endTime: number;
	title: string;
	identifier?: string;
}

export interface IVttCue {
	id: string;
	startTime: number;
	endTime: number;
	text: string;
}

export interface IMediaCache {
	images: Array<{ id: string; url: string }>;
	videos: Array<{
		id: string;
		url: string;
		subtitle_url?: string;
		chapters_url?: string;
		thumbnail_url?: string;
	}>;
	fetchedAt: number;
	expiresAt: number;
}

export enum MediaType {
	IMG = "img",
	VID = "vid",
}

export interface IMediaItem {
	id: string;
	type: string;
	img_url?: string;
	video_url?: string;
	subtitle_url?: string;
	chapters_url?: string;
	thumbnail_url?: string;
}

export interface IImageData {
	id: string;
	url: string;
}

export interface IVideoData {
	id: string;
	url: string;
	subtitle_url?: string;
	chapters_url?: string;
	thumbnail_url?: string;
}
